import DrawService from './DrawService';

export const DRAW_OVERLAY_DEFAULT_WIDTH_PX = 1000;
const DRAW_OVERLAY_MIN_HEIGHT_PX = 400;

/** Uses model.questionWidth when set to a positive number; otherwise {@link DRAW_OVERLAY_DEFAULT_WIDTH_PX}. */
export function getDrawOverlayWidthPx(model) {
  const w = Number(model?.questionWidth);
  return Number.isFinite(w) && w > 0 ? Math.round(w) : DRAW_OVERLAY_DEFAULT_WIDTH_PX;
}

/**
 * Same response shape as Draw (drawing, elements, text). Width from model.questionWidth or 1000px;
 * height comes from rendered question text (set on model.graphHeight before init / via resizeToHeight).
 */
export default class DrawOverlayService extends DrawService {
  type = 'DrawOverlay';

  getLabel = () => {
    return 'drawOverlay';
  }

  initialize() {
    this.model.graphWidth = getDrawOverlayWidthPx(this.model);
    if (!this.model.graphHeight || this.model.graphHeight < DRAW_OVERLAY_MIN_HEIGHT_PX) {
      this.model.graphHeight = DRAW_OVERLAY_MIN_HEIGHT_PX;
    }
    this.model.hasGraph = false;
    this.model.imageSource = this.model.imageSource || null;
    super.initialize();
  }

  runtimeObjectReady() {
    this.model.hasGraph = false;
    this.model.graphWidth = getDrawOverlayWidthPx(this.model);
    super.runtimeObjectReady();
    if (this.canvas) {
      this.canvas.setBackgroundColor('transparent', () => this.canvas.renderAll());
    }
    if (this.drawCanvas) {
      this.drawCanvas.setBackgroundColor('transparent', () => this.drawCanvas.renderAll());
    }
  }

  resizeToHeight = (height) => {
    const h = Math.max(Math.ceil(height), DRAW_OVERLAY_MIN_HEIGHT_PX);
    this.model.graphHeight = h;
    if (!this.canvas || !this.drawCanvas) {
      return;
    }
    const w = this.getWidth();
    this.canvas.setWidth(w);
    this.canvas.setHeight(h);
    this.canvas.calcOffset();
    this.drawCanvas.setWidth(w);
    this.drawCanvas.setHeight(h);
    this.drawCanvas.calcOffset();
    this.drawGraph();
    this.showResponse();
  }
}
